<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>
      <v-card-text fluid class="centered-tabs mt-3 mx-1" >
        <v-container>
          <v-row>
            <v-col>
              <DocumentLineViewer
                  ref="documentLineViewer"
                  :taskInfo="taskInfo"
                  :service="invoiceDocumentationService"
                  @selectedOffer="v => { $refs.invoiceDocumentationForm.setEditData(v); selectedDoc = v }"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <InvoiceDocumentationForm
                  read-only
                  ref="invoiceDocumentationForm"
                  hide-button
                  :task-info="taskInfo"
                  :disable-process="isProcessDisabled"
                  :disable-sign="isSigned"
                  sign-mode
                  @closeDialog="closeDialog"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

import DocumentLineViewer from '@/modules/book/views/task/components/DocumentLineViewer';
import InvoiceDocumentationForm from '@/modules/book/views/task/components/InvoiceDocumentationForm.vue';
import InvoiceDocumentationService from '@/modules/book/services/task-documentation/invoice-documentation-service';

export default {
  name: 'OfferSignDialog',
  components: {
    InvoiceDocumentationForm,
    DocumentLineViewer
  },
  props: {
    taskInfo: {},
    documentList: []
  },
  data() {
    return {
      selectedDoc: {},
      dialog: false,
      wasRequired: true,
      offerId: null,
      invoiceDocumentationService: InvoiceDocumentationService,
      item: {},
      height: null,
      statusList: []
    }
  },
  computed: {
    isProcessDisabled() {
      if (!this.taskInfo
          || !this.taskInfo.taskStatus
          || this.taskInfo.taskStatus.length === 0
          || !this.selectedDoc
          || !this.selectedDoc.id) return false;

      let isProcessed = false;
      this.taskInfo.taskStatus.forEach(status => {
        if (status.action === 'INVOICE_SEND' && status.objectId === this.selectedDoc.id) {
          isProcessed = true;
        }
      });
      return isProcessed;
    },
    isSigned() {
      if (!this.taskInfo
          || !this.taskInfo.taskStatus
          || this.taskInfo.taskStatus.length === 0
          || !this.selectedDoc
          || !this.selectedDoc.id) return false;

      let isSigned = false;
      this.taskInfo.taskStatus.forEach(status => {
        if (status.action === 'INVOICE_SIGN' && status.objectId === this.selectedDoc.id) {
          isSigned = true;
        }
      });
      return isSigned;
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$refs.documentLineViewer.clearData();
      this.$emit('updateData');
    },
    openDialog() {
      this.dialog = true;
      this.$refs.documentLineViewer.setActiveDocument();
    }
  }
}
</script>

